import { UIManager } from './ui/UIManager';
import './styles/main.css';
import { realtimeClient } from './realtime/instance';
import { GameApplication } from './game/app/GameApplication';

realtimeClient.start();
const uiLayer = document.getElementById('ui-layer');
const container = document.getElementById('game-container');
if (!uiLayer || !container) throw new Error('Missing game containers');
new UIManager(uiLayer).showBootScreen();

const application = new GameApplication(container, uiLayer);
application.start();
import.meta.hot?.dispose(() => application.dispose());
